import React from 'react';
import PropTypes from 'prop-types';
import Typography from 'Components/UI/Typography';
import moment from 'moment';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classNames from 'classnames';
import { shortGeneralDateWithDay } from 'Consts/DateFormats';

const useStyles = makeStyles(() => ({
  root: {
    flex: '1',
  },
}));

function ReadOnlyDateNoLabel({
  value,
  label,
  ...rest
}) {
  const classes = useStyles();
  if (!value) {
    return '';
  }

  return (
    <div className={classNames(classes.root)}>
      <Typography
        variant="h5"
        className={classes.root}
        color="primaryGray"
        {...rest}
      >
        {moment(value).format(shortGeneralDateWithDay)}
      </Typography>
    </div>
  );
}

ReadOnlyDateNoLabel.defaultProps = {
  value: null,
};

ReadOnlyDateNoLabel.propTypes = {
  value: PropTypes.node,
};

export default ReadOnlyDateNoLabel;
